<template>
  <div class="event-page">
    <template v-if="event && !isLoading">
      <event-participant />
    </template>

    <div class="event-page__loading" v-else-if="isLoading">
      {{ $t("event.loading") }}
    </div>

    <div class="event-page__loading" v-else-if="is403Error">
      {{ $t("event.error403") }}
    </div>
  </div>
</template>

<script>
import EventParticipant from "../components/Custom/EventParticipant.vue";
import { mapGetters, mapState } from "vuex";
import { Websocket } from "@/helpers/websocket";

export default {
  name: "EventPage",
  components: { EventParticipant },

  data() {
    return {
      isLoading: false,
      socket: new Websocket(),
      is403Error: false
    };
  },

  computed: {
    ...mapState("event", ["event"]),
    ...mapGetters("event", [
      "isEventMontage",
      "isServiceShown",
      "isSpecialProject",
      "isPartTime",
      "isOrganizerAndMedia",
      "isUserRoleInstaller"
    ])
  },

  methods: {
    async load() {
      try {
        const id = this.$route.params.id;
        this.isLoading = true;
        await this.$store.dispatch("event/get", id);
        if (this.event.catalog_template_id && !this.isUserRoleInstaller) {
          await this.$store.dispatch("eventCatalog/fetchInfo", {
            eventId: id,
            templateId: this.event.catalog_template_id
          });
        } else {
          this.$store.commit("eventCatalog/SET_INFO", {});
        }
        this.$store.commit(
          "passes/SET_AUTO_PASSES_AMOUNT",
          this.event.car_passes_count || 0
        );
        this.$store.commit(
          "passes/SET_PERSONAL_PASSES_AMOUNT",
          this.event.quota.certificate_count || 0
        );
        this.$store.commit(
          "passes/SET_MONTAGE_PASSES_AMOUNT",
          this.event.quota.installation_count || 0
        );
        this.isLoading = false;
        if (this.isServiceShown) {
          this.$store.dispatch("services/getCart", this.$route.params.id);
        }
      } catch (e) {
        this.is403Error = e.error_data?.response?.status === 403;
      } finally {
        this.isLoading = false;
      }
    },

    connectWebsocket() {
      const id = this.$route.params.id;
      this.socket.connectParticipant(id, data => {
        if (data.personalPass) {
          this.$store.dispatch(
            "passes/updatePersonalPassStatus",
            data.personalPass
          );
        }
        if (data.carPass) {
          this.$store.dispatch("passes/updateCarPassStatus", data.carPass);
        }
        if (data.catalogOrder) {
          this.$store.dispatch(
            "event/updateCatalogStatuses",
            data.catalogOrder.status
          );
        }
      });
    }
  },

  created() {
    this.load();
    this.connectWebsocket();
  },
  beforeDestroy() {
    if (this.event && this.event.id) {
      this.socket.disconnectParticipant(this.event.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.event-page {
  min-height: 100%;
  flex-grow: 1;

  display: flex;
  flex-direction: column;

  &__loading {
    margin: auto;

    font-size: 16px;
    font-weight: 500;

    color: #6d7179;

    padding: 20px;
  }
}
</style>
